/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Whether the admission belongs to this project or to the whole organization.
 */
export const UserSessionWorkloadAdmissionTier = {
  Project: "project",
  Organization: "organization",
} as const;
/**
 * Whether the admission belongs to this project or to the whole organization.
 */
export type UserSessionWorkloadAdmissionTier = OpenEnum<
  typeof UserSessionWorkloadAdmissionTier
>;

/**
 * An admission that lets a workload in.
 */
export type UserSessionWorkloadAdmission = {
  /**
   * The workload_identity_admissions row.
   */
  id: string;
  /**
   * The operator-chosen label for the admission.
   */
  name?: string | undefined;
  /**
   * Whether the admission belongs to this project or to the whole organization.
   */
  tier: UserSessionWorkloadAdmissionTier;
};

/** @internal */
export const UserSessionWorkloadAdmissionTier$inboundSchema: z.ZodMiniType<
  UserSessionWorkloadAdmissionTier,
  unknown
> = openEnums.inboundSchema(UserSessionWorkloadAdmissionTier);

/** @internal */
export const UserSessionWorkloadAdmission$inboundSchema: z.ZodMiniType<
  UserSessionWorkloadAdmission,
  unknown
> = z.object({
  id: z.string(),
  name: z.optional(z.string()),
  tier: UserSessionWorkloadAdmissionTier$inboundSchema,
});

export function userSessionWorkloadAdmissionFromJSON(
  jsonString: string,
): SafeParseResult<UserSessionWorkloadAdmission, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserSessionWorkloadAdmission$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserSessionWorkloadAdmission' from JSON`,
  );
}
